import React from 'react';
import { InstagramIcon, FacebookIcon, LinkedinIcon, MessageCircleIcon, MapPinIcon, PhoneIcon, MailIcon } from 'lucide-react';
export function Footer() {
  return <footer id="contacto" className="bg-[#050505] pt-20 pb-10 border-t border-white/10" data-id="element-148">
      <div className="container mx-auto px-6 lg:px-12" data-id="element-149">
        {/* Main Footer Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8 mb-16" data-id="element-150">
          {/* Column 1: Brand */}
          <div data-id="element-151">
            <div className="flex items-center space-x-2 mb-6" data-id="element-152">
              <div className="w-8 h-8 rounded-full bg-brand-black border border-brand-yellow flex items-center justify-center" data-id="element-153">
                <span className="text-brand-yellow font-heading font-bold text-sm" data-id="element-154">
                  DE
                </span>
              </div>
              <span className="text-white font-heading font-bold tracking-wider text-lg" data-id="element-155">
                DOCTOR ECOMMERCE
              </span>
            </div>
            <h3 className="text-brand-yellow font-heading text-xl italic mb-4" data-id="element-156">
              La cura para negocios estancados.
            </h3>
            <p className="text-brand-gray text-sm leading-relaxed mb-6" data-id="element-157">
              En Doctor Ecommerce no gestionamos redes, operamos sistemas de
              adquisición de alto rendimiento. Con sede estratégica en Tampa,
              Florida, servimos a dueños de negocios en todo Estados Unidos,
              transformando presupuestos publicitarios en máquinas de generación
              de llamadas y ventas diarias.
            </p>
            <div className="flex space-x-4" data-id="element-158">
              <a href="#" className="text-brand-yellow hover:text-white transition-colors" data-id="element-159">
                <InstagramIcon className="w-5 h-5" data-id="element-160" />
              </a>
              <a href="#" className="text-brand-yellow hover:text-white transition-colors" data-id="element-161">
                <FacebookIcon className="w-5 h-5" data-id="element-162" />
              </a>
              <a href="#" className="text-brand-yellow hover:text-white transition-colors" data-id="element-163">
                <LinkedinIcon className="w-5 h-5" data-id="element-164" />
              </a>
              {/* Using MessageCircle as a placeholder for TikTok icon since lucide doesn't have a perfect match */}
              <a href="#" className="text-brand-yellow hover:text-white transition-colors" data-id="element-165">
                <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" data-id="element-166">
                  <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" data-id="element-167" />
                </svg>
              </a>
            </div>
          </div>

          {/* Column 2: Servicios */}
          <div data-id="element-168">
            <h4 className="text-brand-yellow font-heading font-bold uppercase tracking-wider mb-6" data-id="element-169">
              Servicios
            </h4>
            <ul className="space-y-4 text-sm text-brand-gray" data-id="element-170">
              <li className="hover:text-white transition-colors cursor-pointer" data-id="element-171">
                Meta Ads · Google Ads · TikTok Ads · YouTube Ads
              </li>
              <li className="hover:text-white transition-colors cursor-pointer" data-id="element-172">
                Email · SMS · Retargeting Automatizado
              </li>
              <li className="hover:text-white transition-colors cursor-pointer" data-id="element-173">
                Automatización con IA para Ventas 24/7
              </li>
              <li className="hover:text-white transition-colors cursor-pointer" data-id="element-174">
                Funnels Quirúrgicos por Industria
              </li>
              <li className="hover:text-white transition-colors cursor-pointer" data-id="element-175">
                Blindaje Digital & Anti-Ban
              </li>
              <li className="hover:text-white transition-colors cursor-pointer" data-id="element-176">
                PR Digital & Posicionamiento en Medios
              </li>
              <li className="hover:text-white transition-colors cursor-pointer" data-id="element-177">
                CRM & Data Tracking Avanzado
              </li>
              <li className="hover:text-white transition-colors cursor-pointer" data-id="element-178">
                Video Marketing IA · SEO · Branding
              </li>
              <li className="hover:text-white transition-colors cursor-pointer" data-id="element-179">
                Gestión de Reputación · Google Maps
              </li>
              <li className="hover:text-white transition-colors cursor-pointer" data-id="element-180">
                Diseño Web · Landing Pages · CRO
              </li>
            </ul>
          </div>

          {/* Column 3: Recursos */}
          <div data-id="element-181">
            <h4 className="text-brand-yellow font-heading font-bold uppercase tracking-wider mb-6" data-id="element-182">
              Recursos
            </h4>
            <ul className="space-y-4 text-sm text-brand-gray" data-id="element-183">
              <li className="flex items-center hover:text-white transition-colors cursor-pointer" data-id="element-184">
                <span className="text-brand-yellow mr-2 text-xs" data-id="element-185">›</span> Blog
                de Estrategia
              </li>
              <li className="flex items-center hover:text-white transition-colors cursor-pointer" data-id="element-186">
                <span className="text-brand-yellow mr-2 text-xs" data-id="element-187">›</span> Casos
                de Éxito
              </li>
              <li className="flex items-center hover:text-white transition-colors cursor-pointer" data-id="element-188">
                <span className="text-brand-yellow mr-2 text-xs" data-id="element-189">›</span>{' '}
                Política de Privacidad
              </li>
              <li className="flex items-start hover:text-white transition-colors cursor-pointer" data-id="element-190">
                <span className="text-brand-yellow mr-2 text-xs mt-1" data-id="element-191">›</span>{' '}
                Términos y<br data-id="element-192" />
                Condiciones
              </li>
            </ul>
          </div>

          {/* Column 4: Contacto */}
          <div data-id="element-193">
            <h4 className="text-brand-yellow font-heading font-bold uppercase tracking-wider mb-6" data-id="element-194">
              Contacto Directo
            </h4>
            <ul className="space-y-4 text-sm text-brand-gray mb-8" data-id="element-195">
              <li className="flex items-start" data-id="element-196">
                <MapPinIcon className="w-4 h-4 text-brand-yellow mr-3 mt-0.5 flex-shrink-0" data-id="element-197" />
                <span data-id="element-198">1001 WATER ST, TAMPA FL 33602</span>
              </li>
              <li className="flex items-center" data-id="element-199">
                <PhoneIcon className="w-4 h-4 text-brand-yellow mr-3 flex-shrink-0" data-id="element-200" />
                <span data-id="element-201">(402) 872-0639</span>
              </li>
              <li className="flex items-center" data-id="element-202">
                <MailIcon className="w-4 h-4 text-brand-yellow mr-3 flex-shrink-0" data-id="element-203" />
                <span data-id="element-204">doctor.ecommerceus@gmail.com</span>
              </li>
            </ul>

            <div className="space-y-3" data-id="element-205">
              <button className="w-full bg-brand-green hover:bg-brand-green/90 text-white font-bold py-3 px-4 rounded flex items-center justify-center transition-colors" data-id="element-206">
                <MessageCircleIcon className="w-5 h-5 mr-2" data-id="element-207" />
                Habla con un Especialista
              </button>
              <button className="w-full bg-brand-yellow hover:bg-brand-yellow/90 text-brand-black font-bold py-3 px-4 rounded flex items-center justify-center transition-colors" data-id="element-208">
                <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-209">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" data-id="element-210" />
                </svg>
                RESERVAR DIAGNÓSTICO
              </button>
            </div>
          </div>
        </div>

        {/* Bottom Bar: Partners & Form */}
        <div className="border-t border-white/10 pt-10 flex flex-col lg:flex-row justify-between items-start lg:items-center gap-10" data-id="element-211">
          {/* Partners */}
          <div className="w-full lg:w-1/2" data-id="element-212">
            <h5 className="text-brand-gray text-xs font-bold tracking-widest uppercase mb-4" data-id="element-213">
              Partners Certificados y Tecnología de Élite
            </h5>
            <div className="flex flex-wrap gap-3" data-id="element-214">
              <div className="bg-white rounded px-3 py-2 h-10 flex items-center justify-center min-w-[80px]" data-id="element-215">
                <span className="text-black text-[10px] font-bold" data-id="element-216">Meta</span>
              </div>
              <div className="bg-white rounded px-3 py-2 h-10 flex items-center justify-center min-w-[80px]" data-id="element-217">
                <span className="text-black text-[10px] font-bold" data-id="element-218">
                  Google Ads
                </span>
              </div>
              <div className="bg-white rounded px-3 py-2 h-10 flex items-center justify-center min-w-[80px]" data-id="element-219">
                <span className="text-black text-[10px] font-bold" data-id="element-220">
                  CERTIFIED
                </span>
              </div>
              <div className="bg-white rounded px-3 py-2 h-10 flex items-center justify-center min-w-[80px]" data-id="element-221">
                <span className="text-black text-[10px] font-bold" data-id="element-222">
                  Shopify
                </span>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div className="w-full lg:w-1/2" data-id="element-223">
            <h5 className="text-brand-gray text-xs font-bold tracking-widest uppercase mb-4" data-id="element-224">
              ¿Quieres que te contactemos?
            </h5>
            <form className="flex flex-wrap gap-3" onSubmit={e => e.preventDefault()} data-id="element-225">
              <input type="text" placeholder="Tu Nombre" className="bg-transparent border border-white/20 rounded px-4 py-2 text-sm text-white focus:outline-none focus:border-brand-yellow flex-1 min-w-[140px]" data-id="element-226" />
              <input type="email" placeholder="Tu Email" className="bg-transparent border border-white/20 rounded px-4 py-2 text-sm text-white focus:outline-none focus:border-brand-yellow flex-1 min-w-[140px]" data-id="element-227" />
              <input type="tel" placeholder="Tu Teléfono" className="bg-transparent border border-white/20 rounded px-4 py-2 text-sm text-white focus:outline-none focus:border-brand-yellow flex-1 min-w-[140px]" data-id="element-228" />
              <input type="text" placeholder="Nombre de tu Empresa" className="bg-transparent border border-white/20 rounded px-4 py-2 text-sm text-white focus:outline-none focus:border-brand-yellow flex-1 min-w-[140px]" data-id="element-229" />
              <button type="submit" className="bg-brand-yellow hover:bg-brand-yellow/90 text-brand-black font-bold px-6 py-2 rounded text-sm transition-colors" data-id="element-230">
                ENVIAR
              </button>
            </form>
          </div>
        </div>
      </div>
    </footer>;
}